import React from "react";

import { SvgComponentProps } from "../GenericIconType";
import { SvgWrapper } from "../styles";

const InProgressIcon = (props: SvgComponentProps) => {
  const { width, height, color } = props;

  return (
    <SvgWrapper>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.1602 15.1666H5.84021C4.58021 15.1666 3.66021 14.64 3.30687 13.7333C2.94021 12.7866 3.28021 11.6133 4.16021 10.82L7.25354 7.99998L4.16021 5.17998C3.28021 4.38665 2.94021 3.21331 3.30687 2.26665C3.66021 1.35331 4.58021 0.833313 5.84021 0.833313H10.1602C11.4202 0.833313 12.3402 1.35998 12.6935 2.26665C13.0602 3.21331 12.7202 4.38665 11.8402 5.17998L8.74687 7.99998L11.8469 10.82C12.7202 11.6133 13.0669 12.7866 12.7002 13.7333C12.3402 14.64 11.4202 15.1666 10.1602 15.1666ZM8.00021 8.67331L4.83354 11.5533C4.27354 12.0666 4.02687 12.8133 4.24021 13.3666C4.44021 13.88 5.00687 14.1666 5.84021 14.1666H10.1602C10.9935 14.1666 11.5602 13.8866 11.7602 13.3666C11.9735 12.8133 11.7335 12.0666 11.1669 11.5533L8.00021 8.67331ZM5.84021 1.83331C5.00687 1.83331 4.44021 2.11331 4.24021 2.63331C4.02687 3.18665 4.26687 3.93331 4.83354 4.44665L8.00021 7.32665L11.1669 4.44665C11.7269 3.93331 11.9735 3.18665 11.7602 2.63331C11.5602 2.11998 10.9935 1.83331 10.1602 1.83331H5.84021Z"
          fill={color}
        />
      </svg>
    </SvgWrapper>
  );
};

export default InProgressIcon;
